export const enum FORCED_APP_STATE {
  "NO_ACTIVE_DEVICE" = "noActiveDevice",
  "NO_TRANSMISSION" = "noTransmission"
}
